import { TestResultRow } from "../../api/test.type";
import Card from "../shared/card";
import Typography from "../shared/typography";
import { formatTimeStampToHumanReadableDate } from "../utls/time";

interface TestResultItemProps {
  result: TestResultRow;
}

function formatKey(key: string): string {
  const spaced = key
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

function renderValue(value: any): React.ReactNode {
  if (typeof value === "string") {
    const parsed = Date.parse(value);
    if (!isNaN(parsed) && value.includes("-") && value.includes("T")) {
      return formatTimeStampToHumanReadableDate(value);
    }
    return value;
  }
  if (typeof value === "number") {
    return value.toString();
  }
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  if (Array.isArray(value)) {
    return (
      <div className="space-y-0.5">
        {value.map((v, i) => (
          <Typography key={i} variant="body2" className="text-brown-800">
            {renderValue(v)}
          </Typography>
        ))}
      </div>
    );
  }
  if (value && typeof value === "object") {
    return (
      <div className="ml-2 space-y-0.5">
        {Object.entries(value).map(([k, v]) => (
          <div key={k} className="grid grid-cols-[auto_1fr] gap-x-1">
            <Typography variant="body2" className="font-bold text-brown-800">
              {formatKey(k)}:
            </Typography>
            <Typography variant="body2" className="text-brown-800">
              {renderValue(v)}
            </Typography>
          </div>
        ))}
      </div>
    );
  }
  return String(value);
}

export default function TestResultItem({ result }: TestResultItemProps) {
  const { id, ...rest } = result;

  return (
    <Card variant="cream" elevation={1} className="w-full max-w-4xl">
      <Card.Body className="space-y-1">
        <div className="grid grid-cols-2 gap-x-4 lg:gap-x-2 gap-y-2 lg:grid-cols-4">
          {Object.entries(rest).map(([key, value]) => {
            if (value === null || value === undefined) return null;
            return (
              <div key={key} className="contents">
                <Typography
                  variant="body2"
                  className="text-brown-800 font-bold"
                >
                  {formatKey(key)}:
                </Typography>
                <Typography variant="body2" className="text-brown-800">
                  {renderValue(value)}
                </Typography>
              </div>
            );
          })}
        </div>
      </Card.Body>
    </Card>
  );
}
